import { designTokens } from "@/shared/styles/tokens";

import { CHAIN } from "../../config/config";
import { BNB_ADMIN_LIST, PULSE_ADMIN_LIST } from "../../constants/admins";
import { ChainType } from "../../constants/enum/enum";

type ChatUserInfo = {
  username?: string;
  position?: number | null;
  family?: string | null;
};

export const getUsernameColor = (user: ChatUserInfo): string => {
  const username = user.username || "";
  const position = user.position;
  const userFamily = user.family;

  if (
    (CHAIN === ChainType.BNB && BNB_ADMIN_LIST.includes(username)) ||
    (CHAIN === ChainType.PLS && PULSE_ADMIN_LIST.includes(username))
  ) {
    return designTokens.color.status.danger;
  }

  if (position !== null && position !== undefined) {
    if (position >= 0 && position <= 2) {
      return designTokens.color.status.special;
    }
    if (position >= 3 && position <= 7) {
      return designTokens.color.status.warning;
    }
  }

  if (userFamily && userFamily !== "No Family") {
    return designTokens.color.status.success;
  }

  return designTokens.color.text.muted;
};
